angular.module("dx.webapp.error", [
	"dx.webapp.navigation",
]);
